"use strict";
angular.module("planCommandMonitorBasicManageModule", [])
    .controller('planCommandMonitorBasicManageCtrl', ['$scope', 'planCommandMonitorService', 'trsHttpService',
        function($scope, planCommandMonitorService, trsHttpService) {
            initStatus();
            initData();
            /**
             * [initData description:初始化数据]
             */
            function initData() {
                $scope.params = {
                    modalname: "baseFuncMgr",
                    method: "getbasefunclist",
                    methodname: "queryDataFromBigScreen",
                    serviceid: "mlf_bigdatascreen",
                    page_no: $scope.page.CURRPAGE - 1,
                    page_size: $scope.page.PAGESIZE
                };                                                
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.params, "get").then(function(data) {
                    $scope.list = data.mapResult.content.content;
                    $scope.page.ITEMCOUNT = data.mapResult.content.totalElements;
                    $scope.page.PAGECOUNT = data.mapResult.content.totalPages;
                });

            }
            /**
             * [initStatus description:初始化状态]
             */
            function initStatus() {
                $scope.page = {
                    "CURRPAGE": 1,
                    "PAGESIZE": 12,
                    "ITEMCOUNT": 0,
                    "PAGECOUNT": 1
                };
                $scope.status = {
                    "copyCurrPage": 1
                };              
            }
            // *
            //  * [scan description] 页面查看按钮链接
            //  * @param  {[type]} url [链接地址] 
            //  * @return {[type]}     [description]
             
            $scope.scan = function(url) {
                window.open(url);
            };
            /**
             * [share description] 打开分享弹窗
             * @param  {[type]} uurl [分享链接地址]
             * @param  {[type]} id   [场景ID]             
             */
            $scope.share = function(id) {
                planCommandMonitorService.share(id, '1', "复制链接和密码");
            };            
            
            /**
             * [pageChanged description] 页面切换
             * @return {[type]} [description]
             */
            $scope.pageChanged = function() {
                initData();
            };
         }
    ]);